import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';

import { loadAnswers } from '../../actions/answers/loadAnswers';
import { AnswerList } from '../../components/AnswerList';
import { WideButton } from '../../components/WideButton';
import { getReviewById } from '../../selectors/reviews';
import { AnswerItemContainer } from '../AnswerItem';
import { getReviewsConfig } from '../../utils/getReviewsConfig/getReviewsConfig';
import { TThunkDispatch } from '../../types/redux';

interface IAnswerListContainerProps {
  reviewId: string;
  inPopup?: boolean;
  areAnswersOpened?: boolean;
}

export function AnswerListContainer({ reviewId, inPopup }: IAnswerListContainerProps) {
  const dispatch = useDispatch<TThunkDispatch>();
  const { answers, hasMoreAnswers, answersPage, areAnswersOpened } = useSelector(getReviewById(reviewId));
  const reviewsConfig = getReviewsConfig();
  const alwaysShowAnswersUnderReview = reviewsConfig.ALWAYS_SHOW_ANSWERS_UNDER_REVIEW;

  const onLoadMoreClick = React.useCallback(() => {
    dispatch(loadAnswers({ reviewId, page: answersPage + 1 }));
  }, [dispatch, reviewId, answersPage]);

  const more = hasMoreAnswers && (
    <WideButton testId="MoreAnswers" onClick={onLoadMoreClick}>
      Показать ещё
    </WideButton>
  );

  if (!areAnswersOpened) {
    return null;
  }

  if (alwaysShowAnswersUnderReview) {
    return (
      <AnswerList more={more}>
        {answers.map(id => (
          <AnswerItemContainer id={id} key={id} inPopup={inPopup} />
        ))}
      </AnswerList>
    );
  }

  return (
    <Responsive desktop>
      <AnswerList more={more}>
        {answers.map(id => (
          <AnswerItemContainer id={id} key={id} inPopup={inPopup} />
        ))}
      </AnswerList>
    </Responsive>
  );
}
